import axios from 'axios';
import Common from '../../componets/Common';

export const obtenerPagoEfectivo = async (invoice, studentCode, authPayment) => {
  const resPagoEfectivo = await axios
    .get(
      `${Common.urlAPI}/ObtenerPagoEfectivo/${invoice}/${studentCode}`,
      authPayment
    )
    .catch((error) => {
      if (error.response.status === 401) {
        alert("El token es invalido para este usuario");
      }
    });

  return resPagoEfectivo;
}
